import { render } from "./UserTableDropdown.vue?vue&type=template&id=a55f24d8"
import script from "./UserTableDropdown.vue?vue&type=script&lang=js"
export * from "./UserTableDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__